module.exports = __webpack_public_path__ + "img/dawn.288afafc.png";